import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isAndroid, isIOS, isBrowser } from "react-device-detect";
import config from '../../config';
import logo from '../../assets/logo-icon.png';
import Video from 'twilio-video';
import Spinner from 'react-bootstrap/Spinner'
import '../../css/SignIn.css';
import axios from 'axios';
import io from 'socket.io-client';

import { UserActions, ConsultationsActions, NavigationActions, InstantActions } from '../../actions';
import { SignIn, Button, Input } from  '../../components'

class InstantVideoScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      instantSession: null,
      participants_dict: {},
      selected_participant_sid: {},
      session_code: '',
      localMediaAvailable: false,
      name: '',
      video_input_device_ids: [],
      current_video_input_id: '',
      current_room: null,
      first_person_join: true,
      participant_count: 0,
    }
    this.socket = null;
  }

  componentDidMount() {
    let props  = this.props || {};
    let match  = props.match || {};
    let params = match.params || {};

    let session_code  = params && params.code  ? params.code  : '';
    if (session_code) {
      this.enterSession(session_code);
      this.setState({ ...this.state, session_code: session_code })
    }
  }

  componentDidUpdate() {
    let session_id         = this.state.instantSession && this.state.instantSession._id ? this.state.instantSession._id : '';

    if (!this.socket && session_id) {
      this.socket = io(config.NOTIF_URL, { path: '/notifications', query: `notification=${session_id}` });
      this.socket.on('INSTANT', (notification) => {

        if (notification.instantSession) {
          let updatedSession = notification.instantSession;
          if (updatedSession) {
            this.setState({ ...this.state, instantSession: updatedSession });
          }
        }

      });
    }
  }

  componentWillUnmount() {
    this.props.instantActions.setJoinedOrLeftSession(this.state.session_code, false);
  }

  renderWaitMessage = () => {
    if (this.state.participant_count !== 1) {
      return null;
    }

    let message_text    = this.state.first_person_join ? 'You are the first participant to join this session' : 'You are currently the only participant in this session';
    let display_waiting = this.state.first_person_join ? true : false;
    let client_provider = this.state.isClient ? ' the provider ' : ' the client ';

    return <div className='flex-container-column' style={{ justifyContent: 'center', alignItems: 'center', position: 'absolute', top: window.innerHeight/3, width: '100%' }}>
      <div className='flex-container-column' style={{ backgroundColor: 'black', padding: 15, borderRadius: 15, width: 280, alignItems: 'center' }}>
        <span className="fas fa-street-view" style={{ fontSize: 40, color: '#1dc2ff', marginBottom: 10 }}></span>
        <span style={{ color: 'white', fontSize: 16, textAlign: 'center' }}>{ message_text }</span>
        { display_waiting ? <div className='flex-container-row' style={{ marginTop: 10, alignItems: 'center' }}>
                              <Spinner as="span" animation="border" size='sm' style={{ color: '#1dc2ff', marginRight: 10 }} />
                              <span style={{ color: '#1dc2ff', fontSize: 16 }}>Waiting for{ client_provider }...</span>
                            </div>
                          : null }
      </div>
    </div>
  }

  render() {
    const showLocalTrack = this.state.localMediaAvailable ? <div id='local-media' className='local-media' ref="localMedia" style={{ borderRadius: 10 }}></div> : '';
    if (!this.state.localMediaAvailable) {

      let instantSession = this.state.instantSession;
      let client_name    = this.state.clientName;
      let provider_name  = this.state.providerName;
      let isClient       = this.state.isClient;
      let isProvider     = this.state.isProvider;

      let display_name   = isClient ? client_name : '';
          display_name   = !isClient && isProvider ? provider_name : display_name;

      let disableJoinBtn = isClient && client_name === '' || isProvider && provider_name === '' ? true : false;
      let allowJoining   = instantSession && (instantSession.status === 'INVITED' || instantSession.status === 'WAITING' || instantSession.status === 'IN_PROGRESS');
          allowJoining   = isClient && instantSession && instantSession.status === 'LEFT' ? true : allowJoining;

      let cant_join_msg  = this.getCantJoinMessage(instantSession);
      let btn_bg_color   = !instantSession || cant_join_msg || disableJoinBtn || !allowJoining ? '#e7e7e7' : '';
      let is_completed   = instantSession && instantSession.status === 'COMPLETED' ? true : false;
          is_completed   = this.state.display_completed ? true : is_completed;
          cant_join_msg  = is_completed ? '' : cant_join_msg;

      return <div className='flex-container-column' style={{ backgroundColor: 'white', justifyContent: 'center', alignItems: 'center', height: window.innerHeight }}>
        <div className='flex-container-column'>
          <span className="fas fa-dog" style={{ fontSize: 120, color: '#1dc2ff', marginLeft: 5 }}></span>
          <div className='flex-container-row' style={{ marginTop: 10, alignItems: 'center', justifyContent: 'center' }}>
            <span className="fas fa-user" style={{ fontSize: 40, color: '#1dc2ff' }}></span>
            <span className="fas fa-video" style={{ fontSize: 20, color: '#66D56F', marginRight: 10, marginLeft: 12 }}></span>
            <span className="fas fa-user-md" style={{ fontSize: 40, color: '#1dc2ff' }}></span>
          </div>
        </div>
        { is_completed ? <div className='flex-container-row' style={{ alignItems: 'center', marginTop: 15 }}>
                          <span className="fas fa-check-circle" style={{ marginRight: 8, fontSize: 25, color: '#66D56F' }}></span>
                          <span style={{ fontWeight: 'bold', fontSize: 24, color: '#4e4e4e'}}>Session Completed</span>
                         </div>
        : <div className='flex-container-column' style={{ alignItems: 'center' }}>
        { this.state.invalidCode
          ? null : <Input  placeholder="Enter Name"
                           value={display_name}
                           style={{ width: 260, marginTop: 30, marginBottom: 5 }}
                           onChange={ (event) => {
                             if (isClient) {
                               this.setState({ ...this.state, clientName: event.target.value });
                             }
                             if (isProvider) {
                               this.setState({ ...this.state, providerName: event.target.value });
                             }
                           }}
                          /> }
          { cant_join_msg ? <span style={{ color: '#1dc2ff', marginTop: 5, marginBottom: 5, textAlign: 'center', width: 280 }}>{ cant_join_msg }</span> : null }
          <div className='flex-container-row' style={{ alignItems: 'center', width: 260 }}>
            <span style={{ fontSize: 13, color: 'grey', marginTop: 5, marginBottom: 5 }}>
              By continuing, you are agreeing to our
              <a className="tos-link" style={{ color: '#1dc2ff' }} target="_blank" href="https://www.teletails.com/tos"> Terms & Conditions</a> and
              <a className="tos-link" style={{ color: '#1dc2ff' }} target="_blank" href="https://www.teletails.com/tos"> Privacy Policy</a>.
            </span>
          </div>
          <span className='flex-container-row button-default' style={{ backgroundColor: btn_bg_color, width: 280, textAlign: 'center', marginTop: 8, justifyContent: 'center', alignItems: 'center', paddingTop: 15, paddingBottom: 15, borderRadius: 10 }}
                onClick={ () => {
                  if (btn_bg_color === '#e7e7e7') {
                    return;
                  }
                  if (isClient) {
                    this.enterSession(instantSession.client_code, client_name, true);
                    this.setState({ ...this.state, enterRoomLoading: true })
                  }
                  if (isProvider) {
                    this.enterSession(instantSession.provider_code, provider_name, true);
                    this.setState({ ...this.state, enterRoomLoading: true })
                  }
                }}>

            { this.state.enterRoomLoading ? <Spinner as="span" animation="border" size='sm' style={{ color: 'white', marginRight: 15 }} />
                                          : <span className="fas fa-video" style={{ fontSize: 20, marginRight: 8, color: 'white' }}></span> }

            <span style={{ fontWeight: 'bold', fontSize: 16 }}>Join Video Session</span>
          </span>
        </div> }
      </div>
    }

    let remoteTrack  = <div id="remote-media" ref="remoteMedia" className='flex-container-row remote-media' style={{ backgroundColor: 'black', height: window.innerHeight, justifyContent: 'center', alignItems: 'center'}}></div>;
    let only_one_cam = this.state.video_input_device_ids && this.state.video_input_device_ids.length === 1 ? true : false;

    return (
      <div id="overall-container" style={{ backgroundColor: 'pink', height: window.innerHeight, width: '100%' }}>
        { showLocalTrack }
        { remoteTrack }
        { this.renderWaitMessage() }
        <div className='flex-container-column' style={{ alignItems: 'center', justifyContent: 'center', position: 'absolute', width: '100%', bottom: 30 }}>
          <div className='flex-container-row call-buttons-container' style={{ alignItems: 'center', justifyContent: 'center', padding: 5 }}>
            <div className='flex-container-row end-call-button-default'
                 style={{ justifyContent: 'center', alignItems: 'center', height: 50, width: 50, borderRadius: 25 }}
                 onClick={ () => {
                   this.leaveRoom();
                 }}>
              <span className="fas fa-phone" style={{ fontSize: 20, color: 'white' }}></span>
            </div>
            { only_one_cam ? null : <div className='flex-container-row button-default'
                 style={{ marginLeft: 10, justifyContent: 'center', alignItems: 'center', height: 50, width: 50, borderRadius: 25 }}
                 onClick={ () => {
                   this.switchCamera();
                 }}>
              <span className="fas fa-sync-alt" style={{ fontSize: 20, color: 'white' }}></span>
            </div> }
          </div>
        </div>
      </div>
    );
  }

  enterSession = (code, name, join_call) => {

    const updateName = name || '';
    const requestURL = `${config.BASE_URL}/enter_room/${code}/${updateName}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }

    axios.get(requestURL, requestConfig).then((response) => {
      let data = response.data || {};
      let twillioToken   = data.twillioToken && data.twillioToken.token ? data.twillioToken.token : '';
      let isClient       = false;
      let isProvider     = false;
      let instantSession = null;
      let clientName     = '';
      let providerName   = '';
      let invalidCode    = false;

      if (data.success) {
        isClient   = data.isClient;
        isProvider = !data.isClient;
        instantSession = data.instantSession;
        clientName = instantSession.client_name || '';
        providerName = instantSession.provider_name || '';
      } else {
        invalidCode = true;
      }

      if (join_call) {
        this.joinRoom();
      }

      this.setState({
        ...this.state,
        validating: false,
        isClient: isClient,
        isProvider: isProvider,
        instantSession: instantSession,
        clientName: clientName,
        roomName: instantSession && instantSession._id ? instantSession._id : '',
        providerName: providerName,
        invalidCode: invalidCode,
        enterRoomLoading: false,
        videoCallToken: twillioToken,
      });

    }).catch((error) => {
      console.log(error)
      this.setState({
        ...this.state,
        enterRoomLoading: false,
      })
    })

  }

  updateSessionStatus = (session, status) => {

    let requestURL = `${config.BASE_URL}/VEG/update_instant_sessions/${session._id}/${status}`;
    let requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } }

    axios.post(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      if (data.success) {

      }
    }).catch((error) => { console.log(error) })

  }

  joinRoom = () => {
    if (!this.state.roomName.trim()) {
        this.setState({ roomNameErr: true });
        return;
    }

    let connectOptions = {
        name: this.state.roomName,
    };

    Video.connect(this.state.videoCallToken, connectOptions).then(this.roomJoined, error => {
        alert('Could not connect to Twilio: ' + error.message);
    });
  }

  roomJoined = (room) => {

    this.setState({
      activeRoom: room,
      localMediaAvailable: true,
      hasJoinedRoom: true,
      current_room: room,
      participant_count: this.state.participant_count + 1,
    });

    this.props.instantActions.setJoinedOrLeftSession(this.state.session_code, true);

    let local_participant = room.localParticipant;

    if (local_participant) {
      let local_participant_sid = local_participant.sid || '';
      if (local_participant_sid) {
        let updated_participants = Object.assign({}, this.state.participants_dict);
        updated_participants[local_participant_sid] ={
          is_local: true,
          info: local_participant,
        }
        this.setState({ ...this.state, participants_dict: updated_participants });
      }
    }

    var localMediaContainer = this.refs.localMedia;
    if (!localMediaContainer.querySelector('video')) {
      this.attachParticipantTracks(room.localParticipant, localMediaContainer);
    }

    //Participants already in the Room when logged in user joins
    room.participants.forEach(participant => {
      var remoteContainer = this.refs.remoteMedia;
      participant.tracks.forEach(publication => {
        if (publication.isSubscribed) {
          const track = publication.track;
          remoteContainer.appendChild(track.attach());
        }
      });
      participant.on('trackSubscribed', function (track) {
        remoteContainer.appendChild(track.attach());
      });
      const that = this;
      participant.on('trackUnsubscribed', function (track) {
        that.detachTrack(track)
      });
      this.setState({ ...this.state, participantStatusChange: !this.state.participantStatusChange, participant_count: this.state.participant_count + 1, first_person_join: false });
    });

    room.on('participantConnected', participant => {
      console.log("Joining: '" + participant.identity + "'");
      var remoteContainer = this.refs.remoteMedia;
      var t = setInterval(this._onEverySecondProvider, 1000);
      participant.tracks.forEach(publication => {
        if (publication.isSubscribed) {
          const track = publication.track;
          remoteContainer.appendChild(track.attach());
        }
      });
      participant.on('trackSubscribed', function (track) {
        remoteContainer.appendChild(track.attach());
      });

      const that = this;
      participant.on('trackUnsubscribed', function (track) {
        that.detachTrack(track)
      });

      this.setState({ ...this.state, participantStatusChange: !this.state.participantStatusChange, interval: t, participant_count: this.state.participant_count + 1, first_person_join: false });
    });

    room.on('participantDisconnected', participant => {
      clearInterval(this.state.interval);
      this.setState({ ...this.state, participantStatusChange: !this.state.participantStatusChange, participant_count: this.state.participant_count - 1 });
    });

    room.on('disconnected', () => {
      this.detachParticipantTracks(room.localParticipant);
      room.participants.forEach(this.detachParticipantTracks);
      this.state.activeRoom = null;
      this.setState({ hasJoinedRoom: false, localMediaAvailable: false, participant_count: 0 });
    });

    navigator.mediaDevices.enumerateDevices().then((devices) => {
      let devices_array    = devices || [];
      let video_device_ids = [];
      devices_array.forEach((device) => {
        let device_info = device || {};
        if (device_info.deviceId && device_info.kind === 'videoinput') {
          video_device_ids.push(device_info.deviceId);
        }
      });
      this.setState({ ...this.state, video_input_device_ids: video_device_ids })
    });

  }

  leaveRoom = () => {
    if (this.state.activeRoom) {
      this.state.activeRoom.disconnect();
    }
    this.props.instantActions.setJoinedOrLeftSession(this.state.session_code, false);
    this.socket.emit('end');
    this.setState({ hasJoinedRoom: false, localMediaAvailable: false, display_completed: true });
  }

  switchCamera = () => {
    let room = this.state.current_room || {};
    let localParticipant = room.localParticipant;

    if (localParticipant) {
      let video_device_ids = this.state.video_input_device_ids || [];
      let current_video_id = this.state.current_video_input_id || '';
      let device_id_to_use = '';

      if (video_device_ids.length === 2 && current_video_id === '' && video_device_ids[1]) {
        device_id_to_use = video_device_ids[1];
      }
      if (video_device_ids.length > 1 && current_video_id !== '') {
        video_device_ids.forEach((device_id) => {
          if (device_id !== current_video_id) {
            device_id_to_use = device_id;
          }
        });
      }
      if (video_device_ids.length === 1) {
        return;
      }

      let tracks_b  = Array.from(localParticipant.videoTracks.values());
      let vd_tracks_b = tracks_b.map((track_pub) => { return track_pub.track }).filter((trk) => { return trk });
      vd_tracks_b.forEach((track) => { track.stop() });

      Video.createLocalVideoTrack({
        deviceId: { exact: device_id_to_use }
      }).then((localVideoTrack) => {
        const tracks  = Array.from(localParticipant.videoTracks.values());
        let vd_tracks = tracks.map((track_pub) => { return track_pub.track }).filter((trk) => { return trk });
        localParticipant.unpublishTracks(vd_tracks);
        this.detachTracks(vd_tracks);
        localParticipant.publishTrack(localVideoTrack);
        const previewContainer = this.refs.localMedia;
        this.attachTrack(localVideoTrack, previewContainer);
        this.setState({ ...this.state, current_video_input_id: device_id_to_use });
      }).catch(function(error) {
         console.error(error)
      });
    }
  }

  attachParticipantTracks = (participant, container) => {
    var tracks = Array.from(participant.tracks.values());
    this.attachTracks(this.getTracks(participant), container);
  }

  attachTracks = (tracks, container) => {
    tracks.forEach( (track) => {
      this.attachTrack(track, container);
    });
  }

  attachTrack = (track, container) => {
    container.appendChild(track.attach());
  }

  getTracks = (participant) => {
    return Array.from(participant.tracks.values()).filter( (publication) => {
      return publication.track;
    }).map( (publication) => {
      return publication.track;
    });
  }

  detachTrack = (track) => {
    track.detach().forEach( (element) => {
      element.remove();
    });
  }

  detachTracks = (tracks) => {
    tracks.forEach(track => {
      track.detach().forEach(detachedElement => {
        detachedElement.remove();
      });
    });
  }

  detachParticipantTracks = (participant) => {
    var tracks = this.getTracks(participant);
    tracks.forEach(this.detachTrack);
  }

  setTokenAndIdentity = (twilioToken, identity) => {
    if (twilioToken && identity) {
      this.setState({ ...this.state, videoCallToken: twilioToken, identity: identity });
    }
  }

  getCantJoinMessage = (instantSession) => {
    let cant_join_msg = '';
    if (!instantSession) {
      cant_join_msg = 'The Session associated with your code has expired'
    }
    if (instantSession && instantSession.status === 'LEFT' && this.state.isClient === false) {
      cant_join_msg = 'The client joined and left the session'
    }
    if (instantSession && instantSession.status === 'COMPLETED') {
      cant_join_msg = 'This Session has been completed'
    }
    if (instantSession && instantSession.status === 'CANCELLED') {
      cant_join_msg = 'This Session has been cancelled'
    }
    return cant_join_msg;
  }

}

const mapStateToProps = (state) => {
  return {

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    instantActions: bindActionCreators(
     { ...InstantActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InstantVideoScreen)
